// Copyright (c) Ensho Health, 2022 to present

import client from './client-http.js';

export async function sendOrder(orderData) {
  try {
    const headers = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };
    let baseRoute = '/requisition/new/';
    const route = orderData.get('service').includes('FULL')
      ? baseRoute + 'full'
      : baseRoute + 'single';
    let response = await client.post(route, orderData, headers);
    return response;
  } catch (error) {
    console.error(error.response.status);
    throw new Error('something went wrong while sending an order');
  }
}
